export default 
{
  type: "countdown",
  data: {
    dateType: "fixed",
    timeEndAnimation: "none",
    labelFormat: "days-hours-minutes-seconds",
    clockFace: "flip",
    labelColor: { r: 204, g: 204, b: 204, a: 1 },
    cardColor: { r: 51, g: 51, b: 51, a: 1 },
    clockWidth: 608,
    autoSize: true,
  },
  children: [],
};
